import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import useUserStore from '../store/userStore';
import cl from './Header.module.css';

// Шапка сайта. Логика «прозрачная над hero, заливается при скролле»
// сделана через CSS-классы. Меню справа меняется в зависимости от того,
// залогинен ли пользователь.

export default function Header() {
    const { profile } = useUserStore();
    const location = useLocation();
    const [scrolled, setScrolled] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    // На главной хедер прозрачный над hero, на остальных всегда залит
    const isHome = location.pathname === '/';

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        // Закрываем мобильное меню при смене маршрута
        setMobileOpen(false);
    }, [location.pathname]);

    const headerCls = [
        cl.header,
        (!isHome || scrolled) ? cl.solid : cl.transparent,
    ].join(' ');

    return (
        <header className={headerCls}>
            <div className={cl.inner}>
                <Link to="/" className={cl.logo}>
                    <span className={cl.logoMark}>SK</span>
                    <span className={cl.logoText}>СтартКласс</span>
                </Link>

                <nav className={`${cl.nav} ${mobileOpen ? cl.navOpen : ''}`}>
                    <NavLink to="/" end className={({ isActive }) =>
                        isActive ? `${cl.navLink} ${cl.navLinkActive}` : cl.navLink}>
                        Главная
                    </NavLink>
                    <NavLink to="/articles" className={({ isActive }) =>
                        isActive ? `${cl.navLink} ${cl.navLinkActive}` : cl.navLink}>
                        Статьи
                    </NavLink>
                    <a href="/#tariff" className={cl.navLink}>Тариф</a>
                    <a href="/#faq" className={cl.navLink}>FAQ</a>
                </nav>

                <div className={cl.right}>
                    {profile ? (
                        <Link to="/cabinet" className={cl.btnPrimary}>
                            Личный кабинет
                        </Link>
                    ) : (
                        <>
                            <Link to="/login" className={cl.btnGhost}>Войти</Link>
                            <Link to="/registration" className={cl.btnPrimary}>
                                Попробовать
                            </Link>
                        </>
                    )}

                    <button className={cl.burger}
                        onClick={() => setMobileOpen(o => !o)}
                        aria-label="Меню">
                        <span></span><span></span><span></span>
                    </button>
                </div>
            </div>
        </header>
    );
}
